import React from 'react';

function Card(props) {
  // Generate descriptive alt text based on image name
  const getAltText = (imgName) => {
    const altMap = {
      'card1.png': 'Residential rooftop solar panel installation on Indian home',
      'card2.png': 'Commercial building rooftop solar panel installation',
      'card3.png': 'Large scale utility solar power plant in India',
      'Cold storage solar.png': 'Solar panels installed on cold storage facility roof',
      'Warehouse solar.png': 'Solar panels on warehouse rooftop for energy efficiency',
      'stock image commercial change.jpg': 'Solar panels on commercial warehouse building',
    };
    return altMap[imgName] || 'Solar panel installation service by Lunar Electric';
  };

  return (
    <div className="card">
      <br />
      
      <div className="text-center">
        <img 
          alt={getAltText(props.img)} 
          src={"./img/"+props.img} 
          className="text-center img-fluid"
          loading="lazy"
          width="400"
          height="300"
        />
      </div>
      <div className="text-center">
        <h3 className="card-title">{props.title}</h3>
      </div>
      <div className="p-3">
        <p className="card-text">
           {props.text}
        </p>
      </div>
    </div>
  );
}
export default Card;
